import { faGlobeAsia } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Nav = () => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const lang = window.localStorage.getItem('lang')
      ? window.localStorage.getItem('lang')
      : 'ar';
    if (lang === 'en') {
      i18n.changeLanguage('en');
      window.localStorage.setItem('lang', 'en');
      document.body.dir = 'ltr';
    } else {
      i18n.changeLanguage('ar');
      window.localStorage.setItem('lang', 'ar');
      document.body.dir = 'rtl';
    }
  }, [i18n]);

  const changeLanguage = () => {
    let lang = 'en';
    if (window.localStorage.getItem('lang'))
      lang = window.localStorage.getItem('lang');
    if (lang === 'en') {
      i18n.changeLanguage('ar');
      window.localStorage.setItem('lang', 'ar');
      document.body.dir = 'rtl';
    } else {
      document.body.dir = 'ltr';

      i18n.changeLanguage('en');
      window.localStorage.setItem('lang', 'en');
    }
  };
  return (
    <nav className='fixed top-0 z-40 w-full  '>
      <div className='mx-auto max-w-8xl px-2 sm:px-6 lg:px-8'>
        <div className='relative flex h-18 gap-4 items-center justify-between'>
          <div className='flex flex-1   items-center justify-start sm:items-stretch sm:justify-start'>
            <div className='flex flex-shrink-0 items-start  justify-start my-4 '>
              <img
                className='h-14  py-0.5 '
                src='../assets/img/logo.svg'
                alt='Your Company'
              />
            </div>
          </div>
          <div className='relative '>
            <div>
              <button
                type='button'
                onClick={changeLanguage}
                className='  text-gray-500 bg-white py-5 px-8 rounded-xl   hover:text-gray-900   '>
                {t('lang')}{' '}
                <FontAwesomeIcon icon={faGlobeAsia} size='1x' color='black' />
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </nav>
  );
};

export default Nav;
